import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import MeasurementTable from "./MeasurementTable";

const ScanLengthWidthArchTables = ({ legScan }: ILegScanProps) => {
	const lengthRows = [
		{ label: "Foot", left: legScan.left_length, right: legScan.right_length },
		{ label: "Arch", left: legScan.left_arch_length, right: legScan.right_arch_length },
		{ label: "1 Met to Heel Tip", left: legScan.left_1met_to_heel_tip, right: legScan.right_1met_to_heel_tip },
		{ label: "5 Met to Heel Tip", left: legScan.left_5met_to_heel_tip, right: legScan.right_5met_to_heel_tip },
		{ label: "HC to Heel Tip", left: legScan.left_hc_to_heel_tip, right: legScan.right_hc_to_heel_tip },
		{
			label: "Lat Arch to Heel Tip",
			left: legScan.left_lat_arch_to_heel_tip,
			right: legScan.right_lat_arch_to_heel_tip
		},
		{
			label: "Med Arch to Heel Tip",
			left: legScan.left_med_arch_to_heel_tip,
			right: legScan.right_med_arch_to_heel_tip
		}
	];

	const widthRows = [
		{ label: "ForeFoot", left: legScan.left_forefoot_width, right: legScan.right_forefoot_width },
		{ label: "Heel", left: legScan.left_heel_width, right: legScan.right_heel_width },
		{ label: "Mid-Foot", left: legScan.left_midfoot_width, right: legScan.right_midfoot_width },
		{ label: "1-5 Met", left: legScan.left_1_5met_width, right: legScan.right_1_5met_width }
	];

	const archHeightRows = [
		{ label: "Arch", left: legScan.left_arc_height, right: legScan.right_arc_height },
		{ label: "Medial Height", left: legScan.left_medial_arch_height, right: legScan.right_medial_arch_height },
		{ label: "Area Height", left: legScan.left_area_arch_height, right: legScan.right_area_arch_height },
		{ label: "Lateral Height", left: legScan.left_lateral_arch_height, right: legScan.right_lateral_arch_height }
	];

	return (
		<div className="measurement-tables-row">
			<MeasurementTable title="Length Measurements" unit="mm" rows={lengthRows} />
			<MeasurementTable title="Width Measurements" unit="mm" rows={widthRows} />
			<MeasurementTable title="Arch Height" unit="mm" rows={archHeightRows} />
		</div>
	);
};

export default ScanLengthWidthArchTables;
